module.exports = __webpack_public_path__ + "img/serviceCharge.0455f0a0.svg";